module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/popups/my-stuff/removed-items/removed-pins/removed-pins.component.less
// module id = ./src/app/components/popups/my-stuff/removed-items/removed-pins/removed-pins.component.less
// module chunks = main